import {forwardRef} from 'react';
import {Icon, Link} from '@ezcater/tapas';
import {faBuildings, faChevronRight} from '@fortawesome/pro-regular-svg-icons';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import {twJoin} from 'tailwind-merge';

import {SelectableCorpAccount} from '@/components/global/layout/EventBar/useOrderAccounts';
import {getCorpDisplayName} from './utils';

type CorpAccountSelectionMenuButtonProps = {
  selectedCorpAccount?: SelectableCorpAccount;
  onClick?: () => void;
  className?: string;
  [key: string]: any;
};

const CorpAccountSelectionMenuButton = forwardRef<
  HTMLButtonElement,
  CorpAccountSelectionMenuButtonProps
>(({selectedCorpAccount, onClick, className, ...rest}, ref) => {
  const {t} = useTranslation('app-bar');

  return (
    <Link
      render={
        <button
          aria-label={t('menus.corporateAccounts.accountPicker.comboboxLabel')}
          ref={ref}
          {...rest}
        />
      }
      className={twJoin('flex w-full max-w-xs items-center justify-between gap-4', className)}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-4">
        {selectedCorpAccount?.logoIconUrl ? (
          <Image
            src={selectedCorpAccount.logoIconUrl}
            alt={t('menus.corporateAccounts.accountPicker.logoIconAlt', {
              accountName: getCorpDisplayName(selectedCorpAccount),
            })}
            width={20}
            height={20}
            className="mt-1 h-5 w-5 shrink-0"
          />
        ) : (
          <Icon className="mt-1 flex h-5 w-5 shrink-0 text-lg" icon={faBuildings} size="small" />
        )}
        <span className="whitespace-normal break-words text-left">
          {getCorpDisplayName(selectedCorpAccount)}
        </span>
      </div>
      <Icon className="mr-2 shrink-0 justify-end font-normal" icon={faChevronRight} size="xsmall" />
    </Link>
  );
});

CorpAccountSelectionMenuButton.displayName = 'CorpAccountSelectionMenuButton';

export default CorpAccountSelectionMenuButton;
